import { render } from "./MiTr.vue?vue&type=template&id=5f8b071c&scoped=true"
import script from "./MiTr.vue?vue&type=script&lang=js"
export * from "./MiTr.vue?vue&type=script&lang=js"

import "./MiTr.vue?vue&type=style&index=0&id=5f8b071c&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8b071c"]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTr});
